// import jwtDecode from 'jwt-decode'
import openNotification from 'utils/Notification'
import history from 'CustomHistory'

export function authHeader() {
  let token = JSON.parse(localStorage.getItem('user'))
  if (token) {
    return 'Basic ' + token
  }
  return {}
}

export function isAuthenticated() {
  return JSON.parse(localStorage.getItem('token'))
}

export function authLogin(response) {
  localStorage.setItem('token', JSON.stringify(response.data.login.token))
  openNotification('success', 'Logged in successfully')
  history.push('/')
}

export function authLogout() {
  openNotification('success', 'Logout Successfully')
  localStorage.removeItem('token')
  history.replace('/')
}

export function loginWithOtp(res) {
  localStorage.setItem('token', JSON.stringify(res.data.loginWithOtp.token))
  history.push('/')
}

export function authWithOtp(response) {
  localStorage.setItem(
    'token',
    JSON.stringify(response.data.loginWithOtpForWeb.token)
  )
  openNotification('success', 'Logged in successfully')
  history.push('/')
}
